import { Tender } from '../models/tendering';

export function sortByRank(tenderList: Tender[]): Tender[] {
  return tenderList.sort((a, b) => {
    return a.rank - b.rank;
  });
}

export function sortByPrice(tenderList: Tender[]): Tender[] {
  return tenderList.sort((a, b) => {
    return a.price - b.price;
  });
}

export function sortByRankingValue(tenderList: Tender[]): Tender[] {
  return tenderList.sort((a, b) => {
    return a.rankingValue - b.rankingValue;
  });
}

export function setTenderingPartRankingByPrice(tenderList: Tender[]): any[] {
  tenderList = sortByPrice(tenderList);
  let rank = 1;
  const rankings: any[] = [];

  tenderList.forEach((t) => {
    rankings.push({tenderID: t.tenderID, rank});
    ++rank;
  });

  return rankings;
}

export function setTenderingPartRankingByRankingValue(tenderList: Tender[]): any[] {
  tenderList = sortByRankingValue(tenderList);
  let rank = 1;
  const rankings: any[] = [];

  tenderList.forEach((t) => {
    rankings.push({tenderID: t.tenderID, rank});
    ++rank;
  });

  return rankings;
}

export function setTenderListRankings(tenderList: Tender[], rankings: any[]): Tender[] {
  tenderList.forEach((t) => {
    const rank = rankings.find(r => r.tenderID === t.tenderID);
    if (rank) {
      t.rank = rank.rank;
    }
    else {
      console.log(t);
    }
  });

  return tenderList;
}
